var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input", {
    staticClass: "span_12 h-4",
    attrs: {
      type: "search",
      id: _vm.elementName,
      placeholder: _vm.placeholder
    },
    on: { change: _vm.change },
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }